import { create } from 'zustand';
import { LinkShareAllDTO, VisionOrganisationBasicDTO } from "../models/vision";
import { VisionLinkedFarmFarmClientT } from "@ruminati/types/vision_linked_farm";
import { VisionInvitationFarmClientT } from "@ruminati/types/vision_invitation";

interface PartnerState {
    linkedFarms: VisionLinkedFarmFarmClientT[] | undefined;
    setLinkedFarms: (r: VisionLinkedFarmFarmClientT[]) => void;
    addLinkedFarm: (r: VisionLinkedFarmFarmClientT) => void;
    removeLinkedFarmById: (r: string) => void;

    invitations: VisionInvitationFarmClientT[] | undefined;
    setInvitations: (r: VisionInvitationFarmClientT[]) => void;

    shareAlls: LinkShareAllDTO[] | undefined;
    setShareAlls: (r: LinkShareAllDTO[]) => void;
    removeShareAllById: (id: string) => void

    miscOrgs: Record<string, VisionOrganisationBasicDTO | 'loading'>
    addMiscOrg: (orgId: string, record: VisionOrganisationBasicDTO | 'loading') => void
    clear: () => void;
}

/**
 * Stores vision related partner data
 */
export const usePartnerStore = create<PartnerState>((set) => ({
  linkedFarms: undefined,
  setLinkedFarms: (linkedFarms: VisionLinkedFarmFarmClientT[]) => set({ linkedFarms }),
  addLinkedFarm: (linkedFarm: VisionLinkedFarmFarmClientT) => set((state) => ({
    linkedFarms: [
      ...(state.linkedFarms ?? []),
      linkedFarm
  ]
  })),
  removeLinkedFarmById: (id: string) => set((state) => ({
      linkedFarms: state.linkedFarms?.filter(lf => lf.linkedFarm.id !== id)
  })),

  invitations: undefined,
  setInvitations: (invitations: VisionInvitationFarmClientT[]) => set({ invitations }),

  shareAlls: undefined,
  setShareAlls: (shareAlls: LinkShareAllDTO[]) => set({ shareAlls }),
  removeShareAllById: (shareAllId: string) => set((state) => ({
    shareAlls: [
        ...(state.shareAlls ?? []).filter((r) => r.id !== shareAllId)
    ]
  })),

  miscOrgs: {},
  addMiscOrg: (orgId: string, record: VisionOrganisationBasicDTO | 'loading') => set((state) => ({
    miscOrgs: Object.assign(state.miscOrgs, {
      [orgId]: record
    })
  })),
  clear: () => set({ linkedFarms: undefined, invitations: undefined, shareAlls: undefined })
})
);
